export const FirebaseConfig = {
	"projectId": "movexfinal",
	"appId": "1:662389364373:web:c5687a0b274fcd76736d9c",
	"databaseURL": "https://movexfinal-default-rtdb.firebaseio.com",
	"storageBucket": "movexfinal.firebasestorage.app",
	"apiKey": "AIzaSyBaGaIw1UfwAe45FBqIHcLP0v5DkxgBFcY",
	"authDomain": "movexfinal.firebaseapp.com",
	"messagingSenderId": "662389364373",
	"measurementId": "G-XVZ0P0FTR6",
	"projectNumber": "662389364373",
	"version": "2"
};